import { render, staticRenderFns } from "./LeadFlowActionFields.vue?vue&type=template&id=96ed7176&scoped=true&"
import script from "./LeadFlowActionFields.vue?vue&type=script&lang=js&"
export * from "./LeadFlowActionFields.vue?vue&type=script&lang=js&"
import style0 from "./LeadFlowActionFields.vue?vue&type=style&index=0&id=96ed7176&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ed7176",
  null
  
)

export default component.exports